import React, { useContext, useEffect, useState } from 'react';
import { AccountContext } from '../../../../components/AccountContext';
import { NotificationContext } from '../../../../components/GrowlNotifications';
import { SUPER_MATCH_DETAILS_QUERY } from '../../services/super-match.service';
import { Loading } from '../../../../components/Loading';
import { growlErrors } from '../../../../utils/NotificationUtil';
import { useParams } from 'react-router-dom';
import { useQuery } from '@apollo/react-hooks';
import { Panel } from 'primereact/panel';
import AsmtTimelineBox from '../../../Assessments/details/AsmtTimelineBox';
import ReportPanel from '../../../Assessments/details/ReportPanel';
import SuperMatchAssessmentDetails from '../../components/details/SuperMatchAssessmentDetails';

const DEFAULT_SUPER_MATCH_STATE = {
  superProfile: {
    jobProfile: {},
  },
  respondent: {},
  assessment: {
    respondent: {},
    template: {},
    compatibleJobProfiles: [],
  },
};

const SuperMatch = () => {
  const currentAccount = useContext(AccountContext);
  const growl = useContext(NotificationContext);

  const { id } = useParams();

  const [superMatch, setsuperMatch] = useState(DEFAULT_SUPER_MATCH_STATE);

  const { loading, error, data } = useQuery(SUPER_MATCH_DETAILS_QUERY, {
    variables: {
      superMatchId: id,
      accountId: currentAccount,
    },
    fetchPolicy: 'no-cache',
  });

  const { account } = data;

  useEffect(() => {
    if (account) {
      setsuperMatch(account.superMatch);
    }
    // eslint-disable-next-line
  }, [account]);

  if (loading) {
    return <Loading />;
  }

  if (error) {
    growlErrors(growl, error);
  }

  const { respondent, assessment, superProfile } = superMatch;

  return (
    <div className="p-grid">
      <div className="p-col-12">
        <div className="brand-detailed-wrapper">
          <div className="p-grid">
            <div className="p-col-12">
              <Panel
                header={`${respondent.firstName} ${respondent.lastName} (SuperMatch, ${superProfile.publicTitle})`}
              >
                <div className="p-grid">
                  <div className="p-col-12 p-md-6">
                    <SuperMatchAssessmentDetails assessment={assessment} respondent={respondent} />
                  </div>
                  <div className="p-col-12 p-md-6">
                    <AsmtTimelineBox asmt={assessment} />
                  </div>
                </div>
              </Panel>
            </div>
          </div>
          <div className="p-grid">
            <div className="p-col">
              <ReportPanel
                respondent={respondent}
                assessment={assessment}
                jobProfiles={[superProfile.jobProfile]}
                superMatchId={superMatch.id}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuperMatch;
